import { ErrorBoundary, FullPageSpinner, ThemeProvider, ToastRenderer } from "@resamare/ui";
import { AuthLoader, AuthProvider, logError, queryClientScanette } from "@resamare/widgets-shared";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import React, { PropsWithChildren } from "react";
import { BrowserRouter } from "react-router-dom";
import { theme } from "@/config/theme";

export function AppProvider({ children }: PropsWithChildren) {
    return (
        <React.Suspense fallback={<FullPageSpinner />}>
            <ThemeProvider theme={theme}>
                <ErrorBoundary onError={logError}>
                    <QueryClientProvider client={queryClientScanette}>
                        <ReactQueryDevtools buttonPosition="bottom-right" />
                        <AuthProvider isScanette>
                            <AuthLoader>
                                <BrowserRouter>{children}</BrowserRouter>
                            </AuthLoader>
                        </AuthProvider>
                    </QueryClientProvider>
                </ErrorBoundary>
                <ToastRenderer />
            </ThemeProvider>
        </React.Suspense>
    );
}
